import React from "react";
import { useSelector } from "react-redux";
import { FaRupeeSign } from "react-icons/fa"; // For Rupee icon
import { Box } from "@mui/system";

const TotalDueFeeCard = () => {
  const { studentDetails } = useSelector((state) => state.user.data);

  const { feeTotal, feeDue, feePaid } = studentDetails;

  return (
    <div className="bg-gradient-to-br from-green-500 via-teal-500 to-blue-500 text-white rounded-xl shadow-xl p-6 transform hover:scale-105 transition-transform duration-300 ease-in-out w-[20rem]">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold uppercase tracking-wide">
          Student Fee Overview
        </h4>
        <FaRupeeSign className="text-2xl" />
      </div>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box className="mb-2">
          <p className="text-sm">
            <b>Total Fee</b>
          </p>
          <p className="text-xl font-semibold">{feeTotal.toLocaleString()}</p>
        </Box>
        <Box className="mb-2">
          <p className="text-sm">
            <b>Paid Fee</b>
          </p>
          <p className="text-xl font-semibold">{feePaid.toLocaleString()}</p>
        </Box>
        <Box>
          <p className="text-sm">
            <b>Due Fee</b>
          </p>
          <p className="text-xl font-semibold">{feeDue.toLocaleString()}</p>
        </Box>
      </Box>
    </div>
  );
};

export default TotalDueFeeCard;
